define('TescoMobile_Checkout/js/view/upgrade-modal-options',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'Magento_Customer/js/customer-data', 'mage/url', 'TescoMobile_Checkout/js/action/get-subscriptions-info', 'mage/translate', 'catalogAddToCart'], function (Component, $, ko, modal, customerData, urlBuilder, actionGetSubscriptionsInfo) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    subscriptionsLoaded: true,
    isLoading: true,
    messages: [],
    tableOpen: false,
    defaults: {
      subscriptionsInfo: [],
      contractEnds: null,
      subscriptionsLimit: 0,
      countSubscriptions: 0,
      addToCartFormSelector: '#product_addtocart_form'
    },
    upgradeForm: null,
    isActionButtonLocked: false,
    initialize: function () {
      this._super();
      $('body').on('upgrade-options-submited', function (e) {
        if (this.subscriptionsLoaded() === true) {
          this.isLoading(false);
        }
      }.bind(this));
      $('body').on('add-to-cart-button-change-state', function (event) {
        this.isActionButtonLocked(Boolean(event === null || event === void 0 ? void 0 : event.enabled));
      }.bind(this));
    },
    initObservable: function () {
      this._super().observe(['subscriptionsInfo', 'subscriptionsLimit', 'countSubscriptions', 'contractEnds', 'isLoading', 'subscriptionsLoaded', 'messages', 'isActionButtonLocked']);
      return this;
    },
    isLoggedIn: function () {
      const customer = customerData.get('customer');
      return !!customer().firstname;
    },
    getSubscriptionsInfo: function (form) {
      let element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      let type = $(form).find('input[name=deal-contract-type]').val();
      this.subscriptionsLoaded(false);
      if (form === undefined) {
        type = $('form').find('input[name=deal-contract-type]').val();
      }
      actionGetSubscriptionsInfo(type).done(function (result) {
        this.subscriptionsInfo(JSON.parse(result)['subscriptions']);
        this.contractEnds(JSON.parse(result)['contract_end_time_text']);
        this.subscriptionsLimit(JSON.parse(result)['subscriptions_limit']);
        this.countSubscriptions(JSON.parse(result)['count_subscriptions']);
      }.bind(this)).fail(function (response) {
        console.log(response);
      }.bind(this)).always(function (response) {
        this.subscriptionsLoaded(true);
        this.isLoading(false);
      }.bind(this));
    },
    setModalElement: function (element) {
      const options = {
        modalClass: 'upgrade-options show-close',
        responsive: true,
        innerScroll: true,
        type: 'slide',
        clickableOverlay: false,
        opened: function (a, b) {
          this._updateContent(element);
        }.bind(this),
        closed: function () {
          $('body').trigger('upgrade-popup-closed');
        }
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      $('body').on('close-all-modals-keep-loader', function (e, elem) {
        $(element).modal('closeModal');
      });
      $('body').on('close-upgrade-modal-options', function (e, elem) {
        $(element).modal('closeModal');
        $('body').loader('hide');
      });
      $('body').on('customer-ajax-logged-in customer-upgrade', function (e, data) {
        if (data && $(data).is('input')) {
          data = data.closest('form');
        }
        this.upgradeForm = data;
        e.preventDefault();
        this.getSubscriptionsInfo(this.upgradeForm, element);
        $(element).modal('openModal');
      }.bind(this));
      $('body').on('customer-login-existing', function (e, data) {
        if (data && $(data).is('input')) {
          data = data.closest('form');
        }
        window.dataProductModalId = $(data).find('[name="item"]').val();
        this.addToCartForm = data;
      }.bind(this));
    },
    moreLessClick: function (data, event) {
      var elementTarget = $(event.currentTarget),
        element = $('.upgrade-option#' + elementTarget.data('mpn'));
      element.toggleClass('open', this.tableOpen);
    },
    _updateContent: function (element) {
      if (this.subscriptionsLoaded() === false) {
        this.isLoading(true);
      }
    },
    setUpgradeMpn: function (mpn) {
      this.isActionButtonLocked(true);
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/setselectedmpn'),
        data: {
          'mpn': mpn
        },
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          this.setSelectedItemType('upgrade');
        }.bind(this),
        error: function () {
          this.isLoading(false);
        }.bind(this)
      });
    },
    setSelectedItemType: function (type) {
      this.isActionButtonLocked(true);
      this.isLoading(true);
      const form = this.upgradeForm ? $(this.upgradeForm) : window.dataProductModalId && $('[data-objectid="' + window.dataProductModalId + '"]').find('form').length > 0 ? $('[data-objectid="' + window.dataProductModalId + '"]').find('form') : $(this.addToCartFormSelector),
        jqForm = form.catalogAddToCart({
          bindSubmit: false
        });
      if (type === 'upgrade') {
        $('body').trigger('add-to-cart-upgrade');
      } else if (type === 'new-contract') {
        $('body').trigger('add-new-contract');
      } else if (type === 'migrate') {
        $('body').trigger('customer-login-paym');
      }
      jqForm.catalogAddToCart('submitForm', jqForm);
    },
    triggerAddToCartUpgrade: function (sub) {
      this.setUpgradeMpn(sub.mpn);
    },
    triggerAddNewContract: function () {
      this.setSelectedItemType('new-contract');
    },
    triggerMigrateToPayMonthly: function () {
      this.setSelectedItemType('migrate');
    }
  });
});

